module.exports = __webpack_public_path__ + "static/media/medication_slider_phone1.24d5328c.png";